webpackJsonp([48],{

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_detail_vue__ = __webpack_require__(354);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c61474_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_detail_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(61);
function injectStyle (context) {
  __webpack_require__(497)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3c61474"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c61474_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_detail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c61474_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_order_detail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  // 中心医院预约详情页
  name: 'OrderDetail',
  data: function data() {
    return {
      patientList: []
    };
  },
  created: function created() {
    this.getBookDetial();
  },

  methods: {
    // 预约成功
    init: function init() {
      Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
        message: '预约成功',
        position: 'bottom',
        duration: 3000
      });
    },

    // 取消预约
    cancleBook: function cancleBook() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var config, params, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.patientList.bill_status !== '已取消')) {
                  _context.next = 8;
                  break;
                }

                config = {
                  headers: {
                    Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token')
                  }
                };
                params = {
                  access_token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token'),
                  schedule_id: _this.patientList.schedule_id,
                  queue_sn: _this.patientList.queue_sn,
                  bill_id: _this.patientList.bill_id
                };
                url = '/new-dpim/webapi/hospital/cancle-book';
                _context.next = 6;
                return _this.$http.post(url, params, config);

              case 6:
                // this.getBookFuyiDetial();
                Object(__WEBPACK_IMPORTED_MODULE_3_mint_ui__["Toast"])({
                  message: '取消成功',
                  position: 'bottom',
                  duration: 3000
                });
                // this.$router.push({ name: 'ChooseRoom' });
                _this.$router.push({ name: 'ChooseRoom', query: { hospitalId: '3' } });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 获取中心预约详情
    getBookDetial: function getBookDetial() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var code, params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                code = _this2.$route.query.billCode;
                params = {
                  access_token: __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('token'),
                  bill_code: code
                };
                url = '/new-dpim/webapi/hospital/get-book-info-one';
                _context2.next = 5;
                return _this2.$http.get(url, { params: params });

              case 5:
                response = _context2.sent;

                _this2.patientList = response.item;
                if (_this2.patientList.bill_status !== '已取消') {
                  _this2.init();
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(169).default
var update = add("cedb61cc", content, true, {});

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".detail-info[data-v-c3c61474]{border-bottom:1px solid #dee2e6}.btn-toolbar[data-v-c3c61474]{padding:20px 10px 0}", "", {"version":3,"sources":["F:/1.前端/ykb-weixin/src/views/appointment/order-detail.vue"],"names":[],"mappings":"AACA,8BACE,+BAAiC,CAClC,AACD,8BACE,mBAA0B,CAC3B","file":"order-detail.vue","sourcesContent":["\n.detail-info[data-v-c3c61474] {\n  border-bottom: 1px solid #dee2e6;\n}\n.btn-toolbar[data-v-c3c61474] {\n  padding: 20px 10px 0 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',[_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.schedule_id,"title":"订单号"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.bill_status,"title":"订单状态"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.queue_sn,"title":"就诊序号"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.advice_time,"title":"就诊时间"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.department,"title":"科室"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.doctor_name,"title":"医生"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.bill_id,"title":"ID号"}}),_vm._v(" "),_c('mt-cell',{staticClass:"detail-info",attrs:{"value":_vm.patientList.patient_phone,"title":"手机号"}})],1),_vm._v(" "),(_vm.patientList.bill_status !== '已取消')?_c('div',{staticClass:"btn-toolbar"},[_c('mt-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.cancleBook}},[_vm._v("取消预约挂号")])],1):_vm._e()])])}
var staticRenderFns = []


/***/ })

});


// WEBPACK FOOTER //
// static/js/48.df4a7f4da0c450943f59.js